import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';

import {
  Tab,
  TabContent,
  TabContentItem,
  TabPanel,
  Tabs,
} from '@/components/ui';
import TariffCardLight from '@/components/ui/TariffCardLight/TariffCardLight';
import { actions as orderActions } from '@/domains/esim/order';

import styles from '../Checkout.module.scss';

const EsimTariffs = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [activeTabPlan, setActiveTabPlan] = useState(0);
  const [activePlan, setActivePlan] = useState(0);

  const tabList = [
    {
      label: t('esim:common.all'),
      data: Object.values(data || {}).flat(),
    },
    ...Object.keys(data || {}).map((key) => ({
      label: key.charAt(0).toUpperCase() + key.slice(1),
      data: data[key],
    })),
  ];

  const cardClickHandler = (item) => {
    setActivePlan(item?.offer_id);
    dispatch(orderActions.setSelectedPlan(item?.offer_id));
    localStorage.setItem('planID', item?.offer_id);
    dispatch(orderActions.setTariffPrice(item?.price));
    dispatch(orderActions.setDisabled(false));
  };

  const renderPlan = (item, index) => {
    return (
      <TariffCardLight
        onClick={() => cardClickHandler(item)}
        item={item}
        key={index}
        className={classNames([
          { [styles.activePlan]: item?.offer_id === activePlan },
        ])}
        itemScope
        itemType='https://schema.org/Product'
      />
    );
  };

  return (
    <Tabs
      active={activeTabPlan}
      itemScope
      itemType='https://schema.org/OfferCatalog'
    >
      <TabPanel className={styles.planTabPanel}>
        {tabList.map((tab, index) => (
          <Tab key={index} onClick={() => setActiveTabPlan(index)}>
            {tab.label}
          </Tab>
        ))}
      </TabPanel>
      <TabContent>
        {tabList?.map((tab, index) => (
          <TabContentItem className={styles.grid} key={index} index={index}>
            {tab?.data?.map(renderPlan)}
          </TabContentItem>
        ))}
      </TabContent>
    </Tabs>
  );
};

export default EsimTariffs;
